(function ($, Drupal, once) {
  Drupal.behaviors.afterImageSlider = {
    attach(context) {
      once('after-image-slider', '.after-image-slider', context)
      .forEach(function (slider) {

        const slideCount = slider.querySelectorAll('.splide__slide').length;

        new Splide(slider, {
          type: 'slide',
          perPage: 1,
          arrows: slideCount > 1,
          pagination: false,
          draggable: slideCount > 1,
        }).mount();

        document.querySelectorAll(
            '.node--type-before-after .image-container-desktop').
            forEach((container) => {

              const beforeImg = container.querySelector('.before-entity img');
              const afterImgs = [...container.querySelectorAll('.after-entity img')];

              const allImgs = [beforeImg, ...afterImgs];

              const beforeContainer = container.querySelector('.before-entity');
              const afterContainer = container.querySelector('.after-entity');

              const zoomBtn = container.querySelector('.zoom-button');

              const ZOOM_LEVEL = 2;

              let scale = 1;

              let beforeX = 0;
              let beforeY = 0;

              let afterX = 0;
              let afterY = 0;

              function updateTransforms() {
                beforeImg.style.transform = `
  translate(${beforeX}px, ${beforeY}px)
  scale(${scale})
`;

                afterImgs.forEach((img) => {
                  img.style.transform = `
    translate(${afterX}px, ${afterY}px)
    scale(${scale})
  `;
                });
              }

              function resetPosition() {

                beforeX = 0;
                beforeY = 0;

                afterX = 0;
                afterY = 0;
              }

              function toggleZoom() {

                if (scale === 1) {

                  scale = ZOOM_LEVEL;

                  zoomBtn.classList.add('is-active');

                }
                else {

                  scale = 1;

                  resetPosition();

                  zoomBtn.classList.remove('is-active');
                }

                updateTransforms();
              }

              zoomBtn.addEventListener('click', toggleZoom);

              // BEFORE
              beforeContainer.addEventListener('mousemove', (e) => {

                if (scale === 1) {
                  return;
                }

                const rect = beforeContainer.getBoundingClientRect();

                const percentX = ((e.clientX - rect.left) / rect.width) - 0.5;
                const percentY = ((e.clientY - rect.top) / rect.height) - 0.5;

                const moveAmount = 120;

                beforeX = -(percentX * moveAmount);
                beforeY = -(percentY * moveAmount);

                updateTransforms();

              });

              // AFTER
              afterContainer.addEventListener('mousemove', (e) => {

                if (scale === 1) {
                  return;
                }

                const rect = afterContainer.getBoundingClientRect();

                const percentX = ((e.clientX - rect.left) / rect.width) - 0.5;
                const percentY = ((e.clientY - rect.top) / rect.height) - 0.5;

                const moveAmount = 120;

                afterX = -(percentX * moveAmount);
                afterY = -(percentY * moveAmount);

                updateTransforms();

              });

              // RESET BEFORE
              beforeContainer.addEventListener('mouseleave', () => {

                if (scale === 1) {
                  return;
                }

                beforeX = 0;
                beforeY = 0;

                updateTransforms();

              });

              // RESET AFTER
              afterContainer.addEventListener('mouseleave', () => {

                if (scale === 1) {
                  return;
                }

                afterX = 0;
                afterY = 0;

                updateTransforms();

              });

              allImgs.forEach((img) => {
                img.style.transition = 'transform .25s ease';
                img.style.transformOrigin = 'center center';
                img.style.willChange = 'transform';
                img.style.cursor = 'move';
              });

            });
      });

    }
  };

})(jQuery, Drupal, once);
